'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeywordField = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _object = require('helpers/object');

var _KeywordSearchBoxPanel = require('./KeywordSearchBoxPanel');

var _SearchBoxField = require('./SearchBoxField');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemToString = function itemToString(i) {
  return (i ? i.name : '').replace(/<[^>]*>/g, '');
};

var KeywordField = exports.KeywordField = function KeywordField(props) {
  return _react2.default.createElement(
    _SearchBoxField.SearchBoxField,
    (0, _extends3.default)({}, (0, _object.pick)((0, _keys2.default)(_SearchBoxField.SearchBoxField.propTypes), props), {
      mobilePlaceholderText: 'Find a studio or activity',
      desktopPlaceholderText: 'a studio or activity',
      isClearable: true,
      itemToString: itemToString,
      prompt: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'search.searchbox.find',
        defaultMessage: 'Find'
      })
    }),
    function (_ref) {
      var getItemProps = _ref.getItemProps,
          highlightedIndex = _ref.highlightedIndex;
      return _react2.default.createElement(_KeywordSearchBoxPanel.KeywordSearchBoxPanel, (0, _extends3.default)({}, (0, _object.pick)((0, _keys2.default)(_KeywordSearchBoxPanel.KeywordSearchBoxPanel.propTypes), props), {
        getItemProps: getItemProps,
        highlightedIndex: highlightedIndex,
        favoritesEnabled: false
      }));
    }
  );
};

KeywordField.propTypes = (0, _extends3.default)({}, (0, _object.omit)(['getItemProps'], _KeywordSearchBoxPanel.KeywordSearchBoxPanel.propTypes), (0, _object.omit)(['prompt', 'mobilePlaceholderText', 'itemToString', 'children'], _SearchBoxField.SearchBoxField.propTypes));